/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';

export default [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/overview"/>
    },
    {
        path: '/auth',
        component: AuthLayout,
        routes: [
            {
                path: '/auth/login',
                exact: true,
                component: lazy(() => import('src/views/Login'))
            },
            {
                path: '/auth/register',
                exact: true,
                component: lazy(() => import('src/views/Register'))
            },
            {
                path: '/auth/recover',
                exact: true,
                component: lazy(() => import('src/views/Recover'))
            },
            {
                path: '/auth/recover/:id',
                exact: true,
                component: lazy(() => import('src/views/RecoverForm'))
            },
            {
                component: () => <Redirect to="/errors/error-404"/>
            }
        ]
    },
    {
        path: '/errors',
        component: ErrorLayout,
        routes: [
            {
                path: '/errors/error-401',
                exact: true,
                component: lazy(() => import('src/views/Error401'))
            },
            {
                path: '/errors/error-404',
                exact: true,
                component: lazy(() => import('src/views/Error404'))
            },
            {
                path: '/errors/error-500',
                exact: true,
                component: lazy(() => import('src/views/Error500'))
            },
            {
                path: '/errors/page-in-process',
                exact: true,
                component: lazy(() => import('src/views/PageInProcess'))
            },
            {
                component: () => <Redirect to="/errors/error-404"/>
            }
        ]
    },
    {
        route: '*',
        component: DashboardLayout,
        routes: [
            {
                path: '/components/forms',
                exact: true,
                component: lazy(() => import('src/views/Forms'))
            },
            {
                path: '/components/typography',
                exact: true,
                component: lazy(() => import('src/views/Typography'))
            },
            {
                path: '/dashboards/analytics',
                exact: true,
                component: DashboardAnalyticsView
            },
            {
                path: '/dashboards/default',
                exact: true,
                component: DashboardDefaultView
            },

            //usuarios proveedores
            {
                path: '/usuarios/proveedor',
                exact: true,
                component: lazy(() => import('src/views/ProveedorList'))
            },

            //Ordenes compra inicia
            {
                path: '/consultas/ordenes-compra',
                exact: true,
                component: lazy(() => import('src/views/PurchaseOrder/List'))
            },
            {
                path: '/consultas/ordenes-compra/:feIni/:feFin',
                exact: true,
                component: lazy(() => import('src/views/PurchaseOrder/List'))
            },
            {
                path: '/consultas/ordenes-compra/:id',
                exact: true,
                component: lazy(() => import('src/views/PurchaseOrder/Detail'))
            },
            {
                path: '/consultas/ordenes-compra/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/PurchaseOrder/Detail'))
            },
            {
                path: '/consultas/ordenes-compra/:id/:dateIni/:dateFin/:tab',
                exact: true,
                component: lazy(() => import('src/views/PurchaseOrder/Detail'))
            },
            //Ordenes compra termina


            //Facturas Inicia
            {
                path: '/consultas/facturas',
                exact: true,
                component: lazy(() => import('src/views/VendorBill/List'))
            },
            {
                path: '/consultas/facturas/:feIni/:feFin',
                exact: true,
                component: lazy(() => import('src/views/VendorBill/List'))
            },
            {
                path: '/consultas/facturas/:id',
                exact: true,
                component: lazy(() => import('src/views/VendorBill/Detail'))
            },
            {
                path: '/consultas/facturas/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/VendorBill/Detail'))
            },
            {
                path: '/consultas/facturas/:id/:tipo/:dateIni/:dateFin/:tab',
                exact: true,
                component: lazy(() => import('src/views/VendorBill/Detail'))
            },

            // Facturas termina

            //Payments Inicia
            {
                path: '/consultas/pagos',
                exact: true,
                component: lazy(() => import('src/views/VendorPaymentList'))
            },
            {
                path: '/consultas/pagos/:id',
                exact: true,
                component: lazy(() => import('src/views/VendorPaymentDetails'))
            },
            {
                path: '/consultas/pagos/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/VendorPaymentDetails'))
            },
            {
                path: '/consultas/pagos/:feIni/:feFin/:r',
                exact: true,
                component: lazy(() => import('src/views/VendorPaymentList'))
            },

            // Payments termina

            // Inventario inicia
            {
                path: '/consultas/inventarios',
                exact: true,
                component: lazy(() => import('src/views/InventoryDetails'))
            },
            {
                path: '/consultas/inventarios/:tab',
                exact: true,
                component: lazy(() => import('src/views/InventoryDetails'))
            },

            {
                path: '/consultas/inventarios/general',
                exact: true,
                component: lazy(() => import('src/views/InventoryDetailsGeneral'))
            },
            {
                path: '/consultas/inventarios/general/:tab',
                exact: true,
                component: lazy(() => import('src/views/InventoryDetailsGeneral'))
            },

            // Inventario termina

            //Bonificaciones inicia
            {
                path: '/consultas/bonificaciones',
                exact: true,
                component: lazy(() => import('src/views/VendorBonificacionesList'))
            },
            {
                path: '/consultas/bonificaciones/:feIni/:feFin/:r',
                exact: true,
                component: lazy(() => import('src/views/VendorBonificacionesList'))
            },
            {
                path: '/consultas/bonificaciones/:id',
                exact: true,
                component: lazy(() => import('src/views/VendorBonificacionesDetails'))
            },
            {
                path: '/consultas/bonificaciones/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/VendorBonificacionesDetails'))
            },
            //Bonificaciones termina

            //Bonificaciones/Devoluciones inicia
            {
                path: '/consultas/credito-factura',
                exact: true,
                component: lazy(() => import('src/views/CreditBillList'))
            },
            {
                path: '/consultas/credito-factura/:type/:id/:tran/:tab',
                exact: true,
                component: lazy(() => import('src/views/CreditBill'))
            },
            //Bonificaciones/Devoluciones termina

            //Notas inicia
            {
                path: '/consultas/notas',
                exact: true,
                component: lazy(() => import('src/views/VendorCreditList'))
            },
            {
                path: '/consultas/notas/:id',
                exact: true,
                component: lazy(() => import('src/views/VendorCreditDetails'))
            },
            {
                path: '/consultas/notas/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/VendorCreditDetails'))
            },
            //Notas termina

            // Ventas inicia
            {
                path: '/consultas/ventas',
                exact: true,
                component: lazy(() => import('src/views/ReporteVentas'))
            },
            {
                path: '/consultas/ventas-general',
                exact: true,
                component: lazy(() => import('src/views/ReporteVentasGeneral'))
            },
            {
                path: '/consultas/ventas-general/:id',
                exact: true,
                component: lazy(() => import('src/views/ReporteVentasGeneral'))
            },
            {
                path: '/consultas/ventas-general/:id/:tab',
                exact: true,
                component: lazy(() => import('src/views/ReporteVentasGeneral'))
            },
            // Ventas termina 

            {
                path: '/management/orders',
                exact: true,
                component: lazy(() => import('src/views/OrderManagementList'))
            },
            {
                path: '/management/orders/:id',
                exact: true,
                component: lazy(() => import('src/views/OrderManagementDetails'))
            },
            {
                path: '/overview',
                exact: true,
                component: OverviewView
            },
            /*
            //Catálogos inicia
            {
                path: '/catalogos/detalles',
                exact: true,
                component: lazy(() => import('src/views/Catalog/List'))
            },
            */
            {
                path: '/soporte/contacto',
                exact: true,
                component: lazy(() => import('src/views/Contact/Support'))

            },
            {
                path: '/manuales/usuarios',
                exact: true,
                component: lazy(() => import('src/views/Handbook/UserHandbook'))
            },
            {
                path: '/consultas/anticipos/:id',
                exact: true,
                component: lazy(() => import('src/views/AdvancePayment/List'))
            },
            {
                component: () => <Redirect to="/errors/error-404"/>
            }
        ]
    }
];
